import { render, staticRenderFns } from "./FBA_shipment.vue?vue&type=template&id=78de1c93"
import script from "./FBA_shipment.vue?vue&type=script&lang=js"
export * from "./FBA_shipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports